import React, { useImperativeHandle, useState, useRef, useContext, useEffect } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import 'devextreme-react/text-area';
import { dataGridErrorHandling, showError } from "../../utils/errorHandling";
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Editing,
  Form,
  Button as GridButton,
  Toolbar,
  Item as GridItem,
  DataGridRef
} from 'devextreme-react/data-grid';
import { useInvitesDataSource } from "../../datasources/InvitesDataSource";
import Button from 'devextreme-react/button';
import { ColumnButtonClickEvent } from "devextreme/ui/data_grid";
import { UsersApi } from "../../data";
import { apiConfiguration } from "../../apiConfig";
import TenantContext from "../../contexts/tenantContext";



type Props = {}

export type PendingInvitePopupHandle = {
  show: () => void,
}

type state = {
  visible: boolean
}

const PopupPendingInvite: React.ForwardRefRenderFunction<PendingInvitePopupHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [state, setState] = useState<state>({ visible: false });
  const dataSource = useInvitesDataSource();
  const gridRef = useRef<DataGridRef>(null);
  const linkPopupRef = useRef<LinkPopupPopupHandle>(null);

  function hideInfo() {
    setState({ visible: false });
  }

  useImperativeHandle(ref, () => ({
    async show() {
      setState({
        visible: true
      });

      gridRef.current?.instance().refresh();
    },
  }));

  const showLink = async (e: ColumnButtonClickEvent) => {
    console.log(e);

    var api = new UsersApi(apiConfiguration);
    var token = await api.getInviteToken({ tenantId: currentTenant.Id, inviteId: e.row?.data.id });

    linkPopupRef.current?.show(token);
  };

  return (
    <React.Fragment>
      <Popup
        visible={state.visible}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        fullScreen={false}
        showTitle={true}
        onHidden={hideInfo}
        title="Inviti in sospeso"
        container=".dx-viewport"
        width="80%"
        height="80%"
      >
        <Position
          at="center"
          my="center"
          of=""
          collision="fit"
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="center"
          options={{
            text: 'Ok',
            onClick: hideInfo
          }}
        />

        <DataGrid
          ref={gridRef}
          dataSource={dataSource}
          onDataErrorOccurred={dataGridErrorHandling}
        >
          <Editing
            allowDeleting={true}
            confirmDelete={true}>
          </Editing>
          <Column type='buttons' alignment='left'>
            <GridButton name="delete" />
            <GridButton
              hint="Visualizza link di invito"
              icon="key"
              onClick={showLink}
            />
          </Column>

          <Column dataField={'invitatoDa'} />
          <Column dataField={'invitatoIl'} dataType="datetime" />
          <Column dataField={'email'} hidingPriority={1} />
          <Column dataField={'scadenza'} dataType="datetime" />
          <Column dataField={'ruoliProposti'} calculateCellValue={(rowData) => {
            return (rowData.ruoliProposti || [])
              .map((role: string) => role)
              .filter(Boolean) // rimuove null/undefined
              .join(", ");
          }} />
        </DataGrid>


      </Popup>
      <LinkPopup ref={linkPopupRef} />
    </React.Fragment>
  );
}

export default React.forwardRef(PopupPendingInvite);


type LinkPopupProps = {}
type LinkPopupPopupHandle = {
  show: (linkText: string) => void,
}
const LinkPopupIntermedio: React.ForwardRefRenderFunction<LinkPopupPopupHandle, LinkPopupProps> = (props, ref) => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [linkText, setLinkText] = useState<string>();

  useImperativeHandle(ref, () => ({
    async show(linkText: string) {
      setLinkText(linkText);
      setPopupVisible(true);
    },
  }));

  return (
    <div>
      <Popup
        visible={popupVisible}
        onHiding={() => setPopupVisible(false)}
        dragEnabled={false}
        closeOnOutsideClick={true}
        showTitle={true}
        title="Link di invito"
        width={400}
        height={300}
      >
         <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="center"
          options={{
            text: 'Ok',
            onClick: ()=>setPopupVisible(false)
          }}
        />

        <div style={{ padding: '0px 10px 10px 0px', wordBreak: 'break-all' }}>
          <span>{window.location.origin}/invite?token={linkText}</span>
        </div>
      </Popup>
    </div>
  );
};

const LinkPopup = React.forwardRef(LinkPopupIntermedio);